import React from 'react';
// This is an empty component that renders nothing
// Used as a replacement when we need to disable menus completely

const TiptapDisabledMenu = () => {
  return null;
};

export default TiptapDisabledMenu;
